module.exports = __webpack_public_path__ + "ee7f4712ac4553621d85503cb9a130e5.svg";